exports = module.exports = require("../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n/* stylelint-disable no-duplicate-selectors */\n/* stylelint-disable */\n/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"modules":false,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#0070C2","@font-size-base":"12px","@primary-1 ":"#f2f2f2"}}!./~/antd/lib/icon/style/index.less
// module id = 1213
// module chunks = 0